import { matchRoutes, useLocation } from "react-router-dom";

const routes = [
  { path: "/" },
  { path: "/about-us" },
  { path: "/services" },
  { path: "/services-detail" },
  { path: "/our-team" },
  { path: "/team-single" },
  { path: "/our-history" },
  { path: "/media" },
  { path: "/blog-single" },
  { path: "/our-products" },
  { path: "/project-detail1" },
  { path: "/contact-us" },
  { path: "/faq" },
  {path: '/project-detail1/morcha'},
  {path: '/project-detail1/green-co2-concrete'},
  {path: '/project-detail1/molecular-hydrogen-inhaler'},
  {path: '/project-detail1/solar-dryer'},
  {path: '/project-detail1/bio-degradable-plastic'},
  {path: '/project-detail1/rolltech-coupler'},
  {path: '/project-detail1/lock-seal'},
  {path: '/project-detail1/fuel-additive'},
  {path: '/project-detail1/bomb-sheet-1'}
];

const useCurrentPath = () => {
  const location = useLocation();
  const [{ route }] = matchRoutes(routes, location);

  return route.path;
};

export default useCurrentPath;